export default __webpack_public_path__ + "static/media/Raider's Boots of the Howling Wind.1f0355a9.jpg";